module.exports = __webpack_public_path__ + "static/character-3-7ca032d64789fa878985ec8c7e9c2461.png";